import styled from 'styled-components'

export const VideoWrapper = styled.div`
  position: relative;
  &:before {
    content: '';
    display: block;
    padding-top: 56.56%;
  }

  > * {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
  }
`
